<div
  class="container d-flex justify-content-center align-items-start mt-5"
  style="height: 100vh"
>
  <div
    class="row d-flex justify-content-center"
    style="text-align: center; min-width: 50%"
  >
    <div class="app-header">
      <h1 class="app-title">GymBook</h1>
    </div>

    <ng-content></ng-content>
  </div>
</div>
